import { PropsWithChildren, useMemo } from 'react';

import {
  OperationFormContentContext,
  OperationFormContentContextProps,
} from './operationFormContentContext';

export const OperationFormContentProvider = ({
  children,
  brokerTimezoneOffset,
  operationId,
  createdAt,
  mode,
  canChangeClientAndOrder,
}: OperationFormContentContextProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      brokerTimezoneOffset,
      operationId,
      createdAt,
      mode,
      canChangeClientAndOrder,
    }),
    [
      brokerTimezoneOffset,
      canChangeClientAndOrder,
      operationId,
      createdAt,
      mode,
    ]
  );

  return (
    <OperationFormContentContext.Provider value={value}>
      {children}
    </OperationFormContentContext.Provider>
  );
};
